import {http, onSuccess, onFail} from "./http";

export const getClientBan = (eventPassword) =>
    http.get(`/api/cp/event/${eventPassword}/client/banned`)
        .then(onSuccess, onFail);

export const addClientBan = (eventPassword, clientRegistrationId) =>
    http.post(`/api/cp/event/${eventPassword}/client/${clientRegistrationId}/ban`)
        .then(onSuccess, onFail);

export const deleteClientBan = (eventPassword, clientRegistrationId) =>
    http.delete(`/api/cp/event/${eventPassword}/client/${clientRegistrationId}/ban`)
        .then(onSuccess, onFail);

export const clientEventRegistrationCreate = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/client`, data)
        .then(onSuccess, onFail);

export const clientEventRegistrationUpdate = (eventKey, registrationId, data) =>
    http.post(`/api/cp/event/${eventKey}/client/${registrationId}`, data)
        .then(onSuccess, onFail);

export const addClientEmptyRegistrations = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/client/emptyRegistrations`, data)
        .then(onSuccess, onFail);

export const clientEventRegistrationDelete = (eventKey, registrationId) =>
    http.delete(`/api/cp/event/${eventKey}/clientRegistration/${registrationId}`)
        .then(onSuccess, onFail);

export const clientEventRegistrationsGroupDelete = (eventKey, data) =>
    http.delete(`/api/cp/event/${eventKey}/clientRegistration/group`, {data})
        .then(onSuccess, onFail);

export const clientEventRegistrationsDeleteAll = (eventKey) =>
    http.delete(`/api/cp/event/${eventKey}/clientRegistration/all`,)
        .then(onSuccess, onFail);


export const clientAccessPreModerationGet = (eventPassword, params) =>
    http.get(`/api/cp/event/${eventPassword}/accessPreModeration`, {params})
        .then(onSuccess, onFail);

export const clientFieldChange = (eventKey, payload) =>
    http.post(`/api/cp/event/${eventKey}/client-field/change`, payload)
        .then(onSuccess, onFail);

export const clientBalanceHistory = (clientRegID) =>
    http.get(`/api/cp/event/client/${clientRegID}/balance/history`)
        .then(onSuccess, onFail);

export const clientBalanceHistoryUpdate = (eventKey, clientRegID, action, data) =>
    http.post(`/api/cp/event/${eventKey}/client/${clientRegID}/balance/${action}`, data)
        .then(onSuccess, onFail);
